// extracted by mini-css-extract-plugin
export default {"inputParameters":"InputParameters_inputParameters__YaBis"};